import React from 'react';
import i18next from 'i18next';
import {
  THeader,
  TTableBody,
  TTableRow
} from '../../shared_components/vrr_table/types';
import { TBrandsAPI } from '../../shared_components/vrr_dropdown/types';
import { TBrandRow } from './types';

export const prepareHeader = (): THeader['element'][] => {
  return [
    {
      id: 'brand_id',
      component: (
        <p>
          {i18next
            .t('connected_brand.brand_table.header.brand_id')
            .toUpperCase()}
        </p>
      )
    },
    {
      id: 'brand_name',
      component: (
        <p>
          {i18next
            .t('connected_brand.brand_table.header.brand_name')
            .toUpperCase()}
        </p>
      )
    }
  ];
};

export const prepareLine = (brand: {
  brand_id: string;
  brand_name: string;
}): TBrandRow[] => {
  const header = prepareHeader();
  return Object.values(brand)?.map((cell, index) => ({
    headerId: header[index].id,
    rowId: brand.brand_id.toString(),
    value: cell
  }));
};

const getLine = (line: TBrandRow[]): TTableRow['cellElements'] => {
  return line?.map((cell) => {
    return {
      headerId: cell.headerId,
      id: cell.rowId,
      component: (
        <label className="brand-value" htmlFor={`brands-${line[0].rowId}`}>
          <span>{cell.value}</span>
        </label>
      ),
      value: cell.value
    };
  });
};

export const prepareBody = (
  brands?: TBrandsAPI[]
): TTableBody['rowElements'] => {
  const newBody: TTableBody['rowElements'] = [];
  brands?.forEach((brand) => {
    if (brand.status !== 'hidden') {
      const line = prepareLine({
        brand_id: brand.brand_id.toString(),
        brand_name: brand.brand_name
      });
      newBody.push(getLine(line));
    }
  });

  return newBody;
};
